import { IProperyChangedArgs } from "../../Utilities";
import { BaseProperties, DataEntityBase, ForcePropertyChangedNotification } from "./Model/Base/DataEntityBase";



export class EntityWatcher<EntityType extends DataEntityBase> {

    public RegisterEntity(entity: DataEntityBase) {
        entity.PropertyChanged.Subscribe(this._onPropertyChanged);
    }

    public UnregisterEntity(entity: DataEntityBase) {
        entity.PropertyChanged.Unsubscribe(this._onPropertyChanged);
    }


    public constructor(fn: (entity: EntityType) => Promise<void>, updateCB?: (entity: EntityType) => void) {
        this._updateFn = fn;
        this._updateCB = updateCB;
        window.addEventListener('beforeunload',
            (event) => {
                if (this._updateMap.size) {
                    // EntityWatcher.telemetryManager.TraceEvent('BeforeUnload-DataRemaining', undefined);
                    for (let item of this._updateMap.values())
                        item.trigger();
                    if (!EntityWatcher.unloadFired) {
                        EntityWatcher.unloadFired = true;
                        event.returnValue = 'There are pending changes that need to be sent to the server.  Sure you want to leave?'
                        setTimeout(() => { EntityWatcher.unloadFired = false; }, 1000);
                    }
                }
            }
        );
    }
    private static unloadFired = false;


    private _onPropertyChanged = (params: IProperyChangedArgs) => {

        if (params.property === ForcePropertyChangedNotification && this._updateCB) {
            this._updateCB(params.source);
        }
        else if (params.property !== BaseProperties.writeVersion)
            this.onDataChanged(params.source);
    }

    private createTimeout = (source: EntityType, delay: number, delayOverride = 5000) => {

        var timeoutId: ReturnType<typeof setTimeout> | undefined;
        var overrideId: ReturnType<typeof setTimeout> | undefined;


        //
        // Clears the intitial timeout, doesn't touch the delayOverride
        //
        let clear = () => {
            if (timeoutId)
                clearTimeout(timeoutId);
            if (overrideId)
                clearTimeout(overrideId);
            timeoutId = undefined;
            overrideId = undefined;
            this._updateMap.delete(source);
        }

        let reset = () => {
            if (timeoutId)
                clearTimeout(timeoutId);
            timeoutId = setTimeout(doUpdate, delay);
        }

        //
        // Does the actual update
        //
        let doUpdate = async () => {

            //
            // Clean up the timeouts, remove ourself from the map
            //
            clear();

            //
            // Do the actual update
            //
            // let correlation = EntityWatcher.telemetryManager.GetCorrelation();
            // EntityWatcher.telemetryManager.TraceEvent('onPropertyChanged', correlation, { source: source.Data.name });
            await this._updateFn(source);
            // await DataManager.instance.UpdateItem(correlation, source.Data);
            source.ClearDirty();
            if (this._updateCB) {
                this._updateCB(source);
            }
        }

        //
        // Setup the two timeouts
        //
        timeoutId = setTimeout(doUpdate, delay);
        overrideId = setTimeout(doUpdate, delayOverride);

        //
        // Create the handles.
        //
        return {
            clear: () => { clear() },
            reset: () => { reset() },
            trigger: () => { return doUpdate(); }
        };
    }

    private onDataChanged = (source: EntityType) => {

        let timeout = this._updateMap.get(source);
        if (!timeout) {
            timeout = this.createTimeout(source, 500);
            this._updateMap.set(source, timeout);
        }
        timeout.reset();
    }

    public Clear(data: DataEntityBase) {
        let updater = this._updateMap.get(data);
        if (updater)
            updater.clear();
    }

    private _updateFn: (entity: EntityType) => Promise<void>;
    private _updateCB?: (entity: EntityType) => void;
    private _updateMap = new Map<DataEntityBase, { reset: () => void, clear: () => void, trigger: () => void }>();
    // private static telemetryManager = new TelemetryManager('EntityWatcher');
}

export type BasicEntityWatcher = EntityWatcher<DataEntityBase>;